import FormField from "../form-field";

export default class AgreementField extends FormField {
    constructor(props = {}) {
        super(props);
    }

    _afterInit() {
        this.$input.addEventListener('change', this._handleChange.bind(this));
        this._refresh();
    }

    _handleChange(e) {
        this.controller.setValue(e.target.checked);
    }

    _refresh() {
        this.$input.checked = this.controller.getValue() || false;
        this.$input.dispatchEvent(new Event('change'));
    }
}